import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';

import { useTranslation } from 'react-i18next';
import BadgeCount from '@common/components/badgeCount';
import { ExternalUserObject } from './types';
import Badge from '@common/components/badge';

export default () => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'name',
        label: t('organisation:sync_result_name'),
        options: {
          size: 150,
          render: (user: ExternalUserObject) => (
            <div className="tw-flex tw-flex-col">
              <div className="tw-font-medium">
                {user.firstName} {user.lastName}
              </div>
              <div className="tw-font-normal tw-font-inter">{user.email}</div>
            </div>
          ),
        },
      },
      {
        key: 'dateOfBirth',
        label: t('organisation:sync_result_date_of_birth'),
        options: {
          size: 100,
          render: (user: ExternalUserObject) => (
            <p className="tw-font-normal tw-font-inter">{user.dateOfBirth}</p>
          ),
        },
      },
      {
        key: 'phoneNum',
        label: t('organisation:sync_result_phone_number'),
        options: {
          size: 100,
          render: (user: ExternalUserObject) => (
            <p className="tw-font-normal tw-font-inter">{user.phoneNum}</p>
          ),
        },
      },
      {
        key: 'activeFrom',
        label: t('organisation:sync_result_active_from'),
        options: {
          size: 100,
          render: (user: ExternalUserObject) => (
            <p className="tw-font-normal tw-font-inter">{user.activeFrom}</p>
          ),
        },
      },
      {
        key: 'activeUntil',
        label: t('organisation:sync_result_active_until'),
        options: {
          size: 100,
          render: (user: ExternalUserObject) => <div>{user.activeUntil}</div>,
        },
      },
      {
        key: 'externalId',
        label: t('organisation:sync_result_external_id'),
        options: {
          render: (user: ExternalUserObject) => <div>{user.externalId}</div>,
        },
      },
      {
        key: 'externalNetworkIds',
        label: t('organisation:sync_result_community'),
        options: {
          render: (user: ExternalUserObject) => {
            return user.externalNetworkIds &&
              user.externalNetworkIds.length > 0 ? (
                <div className="tw-space-y-1">
                  <Badge text={user.externalNetworkIds[0].name} />
                  {user.externalNetworkIds.length > 1 && (
                  <BadgeCount
                    title={user.externalNetworkIds.map((networkId: any) => (
                      <div>{networkId.name}</div>
                    ))}
                    count={user.externalNetworkIds.length - 1}
                  />
                )}
                </div>
            ) : (
              <small className="tw-text-gray-400 tw-text-sm">
                {t('organisation:external_users_no_communities_linked')}
              </small>
            );
          },
        },
      },
      {
        key: 'externalFunctionIds',
        label: t('organisation:sync_result_function'),
        options: {
          render: (user: ExternalUserObject) => {
            return user.externalFunctionIds &&
              user.externalFunctionIds.length > 0 ? (
                <div className="tw-space-y-1">
                  <Badge text={user.externalFunctionIds[0].name} />
                  {user.externalFunctionIds.length > 1 && (
                  <BadgeCount
                    title={user.externalFunctionIds.map((functionId: any) => (
                      <div>{functionId.name}</div>
                    ))}
                    count={user.externalFunctionIds.length - 1}
                  />
                )}
                </div>
            ) : (
              <small className="tw-text-gray-400 tw-text-sm">
                {t('organisation:external_users_no_functions_linked')}
              </small>
            );
          },
        },
      },
    ];
    setColumns(baseColumns);
  }, []);

  return columns;
};
